module.exports = __webpack_public_path__ + "img/Secure-Badge.38153edc.svg";